/**
 * Given an untyped error value, attempt to determine if it represents a GraphQL
 * error. This is a quite shotgun approach, because the error could come from
 * any number of layers in the API call chain:
 *
 *   1. SuperAgent → throws error when .abort() is called
 *   2. API Client → catches and potentially transforms the error
 *   3. Apollo Client → wraps it in an ApolloError with networkError
 *   4. Our code → receives the final transformed error
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isGqlAborted = (error: any) => {
  const isAborted: boolean = error.networkError?.code === 'ABORT_ERR'
  || error.networkError?.code === 'ABORTED'
  || error.networkError?.name === 'AbortError'
  || error.message?.includes('AbortError')
  || error.message?.includes('cancelled')
  || error.message?.includes('aborted')
  || error.cause?.name === 'AbortError'
  // SuperAgent specific abort error detection
  || error.networkError?.message?.includes('aborted')
  || error.networkError?.status === 0
  // Apollo/SuperAgent abort creates ServerParseError with undefined JSON
  || (error.networkError?.name === 'ServerParseError'
    && error.networkError?.message?.includes('"undefined" is not valid JSON'))
  || false

  return isAborted
}
